import React from 'react';
import { Helmet } from 'react-helmet-async';

const ProductSchema = ({ product }) => {
  if (!product || !product.products_offers_published?.length) return null;

  const offer = product.products_offers_published[0];

  const name = product.short_name || product.name || "Producto sin nombre";
  const description = product.description || "Descripción no disponible";
  const brand = product?.brand?.brand || "Marca no disponible";
  const image = product.images?.length
    ? `${process.env.REACT_APP_IMAGES_BASE_URL}${product.images[0].path}`
    : "https://www.ejemplo.com/images/default.jpg";

  const price = offer?.price || "0.00";
  const url = `https://elalquilador.com/alquiler-de/${product.slug || "producto"}`;

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": `${name} - Alquiler`,
    "description": description,
    "image": [image],
    "brand": {
      "@type": "Brand",
      "name": brand
    },
    "offers": {
      "@type": "Offer",
      "url": url,
      "priceCurrency": "EUR",
      "price": price,
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "price": price,
        "priceCurrency": "EUR",
        "unitText": "day"
      },
      "availability": "https://schema.org/InStock",
      "businessFunction": "https://schema.org/Rental"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default ProductSchema;